import { useTranslation } from 'react-i18next';
import { IInvalidExceptionList } from '../../../../../models';
import classes from './InvalidExceptionModal.module.scss';

/**
 * @method InvalidExceptionModal
 * @description displays the invalid exception notification
 * @param exceptionList invalid exception list
 */
export const InvalidExceptionModal = ({ exceptionList }: IInvalidExceptionList) => {
  const { t: translate } = useTranslation();

return (
  <div data-testid="invalid-exception-modal">
    <p className={classes['exception-warning-modal-header-title']} data-testid="invalid-exp-subheader">
      {translate('service_wrapper_component.lbl_incorrect_upload_data')}
    </p>
    <div className={classes['exception-warning-modal']}>
      <ul>
        {(exceptionList && exceptionList.length > 0) && (
          exceptionList.map((exception) => (
            <li key={exception} className={classes['invalid-exception-item']} data-testid={`TEST-ID-${exception}`}>
              {exception}
            </li>
          ))
        )}
      </ul>
    </div>
  </div>
);
};
